import React, { useState,useCallback } from "react";
  import {Route, Routes,useNavigate} from 'react-router-dom'
  import MasterPage from "../generatedTablePage/MasterPage";
import ModalComponent from "../components/Modal";
  import { Outlet } from "react-router-dom";
  import AddMaster from "../generatedAddEdit/master/AddMaster";
  import EditMaster from "../generatedAddEdit/master/EditMaster";


const MasterRoutes = () => {
    
    
    return (
        <Routes> 
        
    <Route
    path="/"
    element={<MasterPage/>

    }
    />
    <Route
    path="/edit"
    element={
      <EditMaster/>
    }
  /> 
  <Route
    path="/add"
    element={
      <AddMaster/>
    }
  />

</Routes>
    
        );
    
}
export default MasterRoutes










  